module.exports = __webpack_public_path__ + "img/12-white.7331bda0.svg";